/**
 * @generated SignedSource<<d58844e5c40fffba4d111777031ed5df>>
 * @relayHash 3d64c45566960882e39ef90347730a14
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3d64c45566960882e39ef90347730a14

import { ConcreteRequest } from 'relay-runtime';
export type De_deleteRecommendedMedicationInput = {
  id: string;
};
export type deDeleteRecommendedMedicationMutation$variables = {
  connections: ReadonlyArray<string>;
  input: De_deleteRecommendedMedicationInput;
};
export type deDeleteRecommendedMedicationMutation$data = {
  readonly deDeleteRecommendedMedication: {
    readonly de_RecommendedMedication: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type deDeleteRecommendedMedicationMutation = {
  response: deDeleteRecommendedMedicationMutation$data;
  variables: deDeleteRecommendedMedicationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "deDeleteRecommendedMedicationMutation",
    "selections": [
      {
        "alias": "deDeleteRecommendedMedication",
        "args": (v2/*:: as any*/),
        "concreteType": "De_deleteRecommendedMedicationPayload",
        "kind": "LinkedField",
        "name": "de_deleteRecommendedMedication",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_RecommendedMedication",
            "kind": "LinkedField",
            "name": "de_RecommendedMedication",
            "plural": false,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "deDeleteRecommendedMedicationMutation",
    "selections": [
      {
        "alias": "deDeleteRecommendedMedication",
        "args": (v2/*:: as any*/),
        "concreteType": "De_deleteRecommendedMedicationPayload",
        "kind": "LinkedField",
        "name": "de_deleteRecommendedMedication",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_RecommendedMedication",
            "kind": "LinkedField",
            "name": "de_RecommendedMedication",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteEdge",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "connections"
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "3d64c45566960882e39ef90347730a14",
    "metadata": {},
    "name": "deDeleteRecommendedMedicationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "1219bbc9ce5faba10709000d39ecaa37";

export default node;
